import { fetchRoles, fetchSpecificRole } from './action';

export const rolActions = {
    fetchRoles,
    fetchSpecificRole,
};
